import CopyrightIcon from "@mui/icons-material/Copyright";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";

import {
  Container,
  CopyrightWrapper,
  FooterInfo,
  FooterTypography,
} from "./footer.styled";

const Footer = () => {
  return (
    <Container>
      <FooterInfo>
        <Link
          sx={{ wordWrap: "break-word", cursor: "pointer", fontSize: "16px" }}
          onClick={() =>
            window.open(
              "https://rkbt.ai/privacy-policy",
              "_blank"
            )
          }
        >
          Privacy policy
        </Link>
        -
        <Link
          sx={{ wordWrap: "break-word", cursor: "pointer", fontSize: "16px" }}
          onClick={() =>
            window.open(
              "https://rkbt.ai/terms-and-conditions",
              "_blank"
            )
          }
        >
          Terms & Conditions
        </Link>
      </FooterInfo>
      <CopyrightWrapper>
        <CopyrightIcon />
        <FooterTypography>2023 Vurtech Technologies Ltd</FooterTypography>
      </CopyrightWrapper>
    </Container>
  );
};

export default Footer;
